import { ref, onBeforeUnmount } from 'vue';

export function useBugReportUpload() {
  const uploading = ref(false);
  const uploadError = ref('');
  let controller;
  const cancelUpload = () => controller?.abort('cancelled');
  const upload = async operation => {
    if (uploading.value) throw new Error('Upload already in progress');
    controller = new AbortController();
    const current = controller;
    uploading.value = true;
    uploadError.value = '';
    const timer = setTimeout(() => current.abort('timeout'), 120000);
    try {
      return await Promise.race([
        operation({ signal: current.signal, timeout: 120000 }),
        new Promise((resolve, reject) => {
          current.signal.addEventListener(
            'abort',
            () => reject(new Error('Upload interrupted')),
            { once: true }
          );
        }),
      ]);
    } catch (error) {
      const reason = current.signal.reason;
      if (reason === 'cancelled') uploadError.value = 'cancelled';
      else if (
        reason === 'timeout' ||
        ['ECONNABORTED', 'ETIMEDOUT'].includes(error.code) ||
        error.response?.status === 408
      )
        uploadError.value = 'timeout';
      else if (error.response?.status === 413) uploadError.value = 'too_large';
      else if (error.response?.status === 429)
        uploadError.value = 'rate_limited';
      else uploadError.value = 'failed';
      throw error;
    } finally {
      clearTimeout(timer);
      controller = null;
      uploading.value = false;
    }
  };
  onBeforeUnmount(cancelUpload);
  return { upload, uploading, uploadError, cancelUpload };
}
